module.exports = __webpack_public_path__ + "assets/certificate_pdf/Microsys Solution Certified Specialist – BIG Data, Configuring_1142018.55887ce9.pdf";